import { http } from '../../config/axios'

 const findNotificacao = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/notificacao/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findNotificacao', error)
      throw Error(error.response.data)
    })
}

export default findNotificacao;
